export const getInitials = (name?: string) => {
	const safeName = (name ?? "").trim();
	const parts = safeName.split(" ").filter(Boolean);

	if (parts.length >= 2) {
		return `${parts[0][0] ?? ""}${parts[1][0] ?? ""}`.toUpperCase();
	}
	return safeName.substring(0, 2).toUpperCase();
};
